/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-11-24 11:29:47
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2024-08-29 14:24:27
 */
import Vue from 'vue'
import store from '../../vuex/modules/login'
import { Toast,Dialog  } from 'vant';
/**权限指令**/
const has = Vue.directive('has', {
    bind: function (el, binding, vnode) {
        // 获取页面按钮别名
        let menuAlias = vnode.data.attrs.menuAlias;
        el.addEventListener('click', e => {
            console.log('e',e);
            
           
            /**判断权限中是否存在该别名 */
            if (!Vue.prototype.$_has(menuAlias)) {
               
                // Dialog.alert({
                //     title: '提示',
                //     message: "暂无操作权限",
                //     confirmButtonText: '确定',
                //     confirmButtonColor:'#0491A7'
                //   }).then(() => {
                //     // on close
                    
                //   });
                Toast("暂无操作权限，请联系管理员")
              
            }else{
                binding.value(e); // 调用传进来的函数
            }

        })
    }
});
// 权限检查方法
Vue.prototype.$_has = function (value) {
    let isExist = false;
    // 获取用户权限    
    let btnPermissionsStr = null
    let userInfo = null
    btnPermissionsStr = JSON.parse(localStorage.getItem("padUserinfo")).authorityJson;
    userInfo = JSON.parse(localStorage.getItem('padUserinfo'))
   
    
    if(userInfo.userName == 'admin'||userInfo.userName == 'Admin'){
        return true
    }
    if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        return false;
    }
    if (btnPermissionsStr.includes(value)) {
        isExist = true;
    }
    return isExist;
};

const hasShow = Vue.directive('hasShow', {
    inserted: function (el, binding, vnode) {
        // 获取页面按钮别名
        let menuAlias = vnode.data.attrs.menuAlias;
        
        /**判断权限中是否存在该别名 */
        if (!Vue.prototype.$_hasShow(menuAlias)) {
            el.parentNode.removeChild(el);
        }
    }
});
// 权限检查方法
Vue.prototype.$_hasShow = function (value) {
    let isExist = false;
    // 获取用户权限    
    let btnPermissionsStr = null
    btnPermissionsStr = JSON.parse(localStorage.getItem("padUserinfo")).authorityJson;
    
    // if(userInfo.userName == 'admin'||userInfo.userName == 'Admin'){
    //     return true
    // }
    if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        return false;
    }
    if (btnPermissionsStr.includes(value)) {
        isExist = true;
    }
    return isExist;
};
export {has,hasShow}


// WEBPACK FOOTER //
// ./src/common/util/btnPermissions.ts